import axios from "axios";

// 固定 Basic 认证头（ezrent-web:ezrent-web-secret 的 base64）
const OAUTH_BASIC_AUTH = "Basic ZXpyZW50LXdlYjplenJlbnQtd2ViLXNlY3JldA==";
const OAUTH_BASE = "/oauth2/token";

/**
 * OAuth2 令牌端点（走网关 8080）
 * POST /oauth2/token
 * @param {Object} body
 *   - grant_type: authorization_code | refresh_token | password | wechat-mini
 *   - code / redirect_uri / code_verifier: 授权码模式
 *   - refresh_token: refresh_token 模式必填
 *   - js_code: wechat-mini 模式必填
 *   - username / password: password 模式必填
 *   - merchant_id: 可选，与 username 的 商家ID: 二选一
 *   - scope: 空格分隔，如 profile order device customer finance
 */
/** 令牌端点内部实现：login/refreshAccessToken 共用，不对外暴露 */
function postOAuthToken(body) {
  return axios.post(OAUTH_BASE, new URLSearchParams(body), {
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
      Authorization: OAUTH_BASIC_AUTH,
    },
  });
}

/** OAuth2 密码模式登录（业务后台常用）
 * @param {Object} params
 * @param {string} params.username 会员手机号
 * @param {string} params.password 会员登录密码（明文仅本次 TLS 出现一次）
 */
export function login({ username, password }) {
  return postOAuthToken({
    grant_type: "password",
    client_type: "web",
    username,
    password,
  });
}

/** OAuth2 刷新令牌（refresh_token 模式）
 * @param {string} refreshToken 刷新令牌（TTL 30d，轮换）
 */
export function refreshAccessToken(refreshToken) {
  return postOAuthToken({
    grant_type: "refresh_token",
    client_type: "web",
    refresh_token: refreshToken,
  });
}
